import {useEffect, useState} from 'react';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {fetchMyNominations} from "../../app/DeliveryLeadershipSlice";
import { useDispatch } from "react-redux";
import "./MyNominationDateFilter.css";

export default function MyNominationDateFilter({userEnterpriseID}) {
  const [startDate, setStartDate] = useState(dayjs('2024-07-01'));
  const [endDate, setEndDate] = useState(dayjs());
  
  const dispatch = useDispatch();
  
  useEffect(() => {
    if(userEnterpriseID){
    dispatch(fetchMyNominations(userEnterpriseID,startDate.format('YYYY-MM-DD'),endDate.format('YYYY-MM-DD')));    
    }
  }, [startDate,endDate, userEnterpriseID]);  
  
  return <div className='my_nomination_date_filter'>    
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>                
        <DemoItem>
          <DatePicker value={startDate} onChange={(newValue) => setStartDate(newValue)} format="DD/MM/YYYY" />          
        </DemoItem>
        <span className='date_to_text'>to</span>
        <DemoItem>
          <DatePicker value={endDate} onChange={(newValue) => setEndDate(newValue)} format="DD/MM/YYYY" />
        </DemoItem>                
      </DemoContainer>
    </LocalizationProvider>
  </div>
}
